export const localizeEmobilityNumber = (value: number): string => {
  return Intl.NumberFormat(navigator.language, { maximumFractionDigits: 2 }).format(value)
}
